var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpportunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15054",
    "data-name": "Path 15054",
    d: "M0-682.665H48.552v48.552H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6228",
    "data-name": "Group 6228",
    transform: "translate(-289 -1362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    transform: "translate(295 1368)",
    fill: "#89d2f5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(314.724 1387.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5152",
    "data-name": "Group 5152",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15047",
    "data-name": "Path 15047",
    d: "M-567.582-283.792a21.729,21.729,0,0,1-21.729,21.729,21.729,21.729,0,0,1-21.729-21.729,21.729,21.729,0,0,1,21.729-21.729A21.729,21.729,0,0,1-567.582-283.792Z",
    transform: "translate(611.751 309.903)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    strokeDasharray: "516 35 600 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15048",
    "data-name": "Path 15048",
    d: "M-205.782-411.564a15.774,15.774,0,0,0,15.756-15.756,15.774,15.774,0,0,0-15.756-15.756,15.774,15.774,0,0,0-15.756,15.756A15.774,15.774,0,0,0-205.782-411.564Z",
    transform: "translate(228.222 453.432)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    strokeDasharray: "227 35 600 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15049",
    "data-name": "Path 15049",
    d: "M-127.773-255.546a9.794,9.794,0,0,1-9.783-9.783,9.794,9.794,0,0,1,9.783-9.783,9.794,9.794,0,0,1,9.783,9.783A9.794,9.794,0,0,1-127.773-255.546Z",
    transform: "translate(150.213 291.441)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15050",
    "data-name": "Path 15050",
    d: "M-49.764-99.529a3.815,3.815,0,0,1-3.81-3.81,3.815,3.815,0,0,1,3.81-3.81,3.815,3.815,0,0,1,3.81,3.81A3.815,3.815,0,0,1-49.764-99.529Z",
    transform: "translate(72.204 129.45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15051",
    "data-name": "Path 15051",
    d: "M0-310.119l23.745-23.745",
    transform: "translate(22.44 336.23)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15052",
    "data-name": "Path 15052",
    d: "M-66.119-1.294l-4.767,4.767a1.009,1.009,0,0,0-.294.777l.276,4.4,5.616-5.616-.258-4.109A.336.336,0,0,0-66.119-1.294Z",
    transform: "translate(108.703 2.104)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15053",
    "data-name": "Path 15053",
    d: "M-129.848-10.862l-4.767,4.767a1.01,1.01,0,0,1-.777.294l-4.4-.276,5.616-5.616,4.109.258A.336.336,0,0,1-129.848-10.862Z",
    transform: "translate(177.59 16.83)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunities);
export default __webpack_public_path__ + "static/media/Opportunities.59040bc7ecfccd718421e3e31f71e2fe.svg";
export { ForwardRef as ReactComponent };